import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { AppThunk } from '../../store'
import { SHOW_ERROR_MESSAGE, HIDE_ERROR_MESSAGE, SHOW_UNAVAILABILITY_ALERT, HIDE_UNAVAILABILITY_ALERT } from './types'

export const hideErrorMessage = () => (dispatch: any) => {
    dispatch({
        type: HIDE_ERROR_MESSAGE,
    })
}

export const dispErrorMessage = (dispatch: any, msg: any) => {
    dispatch({
        type: SHOW_ERROR_MESSAGE,
        playload: {
            errMsg: msg,
        },
    })
}

export const showErrorMessage = (msg: any) => (dispatch: any) => {
    dispErrorMessage(dispatch, msg)
}

export const hideUnavailabilityAlert = (): AppThunk<void> => (dispatch: any) => {
    dispatch({
        type: HIDE_UNAVAILABILITY_ALERT,
    })
}

export const globalConfigFetch = () => async (dispatch: any) => {
    const globalConfigArray = await ToktokdocLib.GlobalConfig.findAll()
    if (Array.isArray(globalConfigArray) && globalConfigArray.length > 0) {
        const globalConfig = globalConfigArray[0]
        if (globalConfig.isSystemUnavailable) {
            dispatch({
                type: SHOW_UNAVAILABILITY_ALERT,
                playload: {
                    isSystemBlocked: !!globalConfig.isSystemBlocked,
                    unavailabilityMessage: globalConfig.requiredExpertMessage,
                },
            })
        } else {
            dispatch({
                type: HIDE_UNAVAILABILITY_ALERT,
            })
        }
        globalConfig.onUpdated((obj: any) => {
            if (obj.isSystemUnavailable) {
                dispatch({
                    type: SHOW_UNAVAILABILITY_ALERT,
                    playload: {
                        isSystemBlocked: !!globalConfig.isSystemBlocked,
                        unavailabilityMessage: globalConfig.requiredExpertMessage,
                    },
                })
            } else {
                dispatch({
                    type: HIDE_UNAVAILABILITY_ALERT,
                })
            }
        })
    }
}
